import { Component } from 'react';

// Assets
// Block1 Images
import b1CardImg1 from '../../assets/serviceCard1.svg';
import b1CardImg2 from '../../assets/serviceCard2.svg';
import b1CardImg3 from '../../assets/serviceCard3.svg';

// Block2 Image
import drill from "../../assets/drilling.svg";
import keyway from "../../assets/keyway.svg";
import grind from "../../assets/grinding.svg";
import weld from "../../assets/welding.svg";
import thread from "../../assets/threading.svg";
import tap from "../../assets/tapping.svg";

export default class Service extends Component {

    Block1Card(img,title,desc) {

        return (
            <div className='Service_Block1Card'>
                <div className='Service_Block1CardImage'>
                    <img src={img} alt="Card Image" />
                </div>
                <div className='Service_Block1CardTitle'>
                    {title}
                </div>
                <div className='Service_Block1CardDesc'>
                    {desc}
                </div>
                <div className='Service_Block1CardLine'></div>
                <div className='Service_Block1CardButton'>
                    <button></button>
                    Read More
                </div>
            </div>
        )
    }

    Block1() {

        return (
            <div className='Service_Block1'>
                <div className='Service_Block1TagLine'>
                    Leading The Way In Developing Metal Jobs Faster With More Finishing
                </div>
                <div className='Service_Block1Title'>
                    Service's For Which We Are Known!!
                </div>
                <div className='Service_Block1CardContainer'>
                    {this.Block1Card(b1CardImg1, "Metal Work", "Metalworking is the process of shaping & reshaping metals to create useful objects, parts, assemblies,& large scale structures.")}
                    {this.Block1Card(b1CardImg2, "Machine Assembly","The connection and attachment of parts, sub assemblies, and modules in a definite sequence to produce a finished machine")}
                    {this.Block1Card(b1CardImg3, "Design Consultance", "Design consultants suggest ideas that will create a space or product that integrates form, functionality, and aesthetics.")}
                </div>
            </div>
        );
    }

    Block2Card(title,img,desc) {

        return (
            <div className='Service_Block2Card'>
                <div className='Service_BeforeHover'>
                    <img className="Service_B2CardImage"src={img}/>
                    <div className='Service_B2CardTitle'>
                        {title}
                    </div>
                </div>
                
                <div className='Service_AfterHover'>
                    <div className='Service_B2CardTitle2'>{title}</div>
                    <div className='Service_B2CardDesc'>{desc}</div>
                    <button className="Service_B2CardButton">Read More</button>
                </div>
            </div>
        );
    }

    Block2() {

        return (
            <div className='Service_Block2'>
                <div className='Service_B2Empty'></div>
                <div className='Service_B2Container'>
                    <div className='Service_B2Title'>
                        We help you in developing your product fully finished in time, So that your development is in time..
                    </div>
                    <div className='Service_B2Services'>
                        <div className='Service_List1'>
                            {this.Block2Card("Drilling",drill,"Drilling is a cutting process in which a drill bit is used to cut or enlarge a hole in a solid material")}
                            {this.Block2Card("Tapping",tap,"Tapping draws on the ancient Chinese practice of acupuncture, which teaches that the body's energy travels")}
                            {this.Block2Card("Keyway",keyway,"keyway is used to prevent components from slipping on a shaft and add torque capacity in driven systems")}
                        </div>
                        <div className='Service_List2'>
                            {this.Block2Card("Grinding",grind,"Grining is the process of breaking up particles. Grinding is used to turn the solid blend into a granu")}
                            {this.Block2Card("Threading",thread,"Threading is a manufacturing and metal processing method used to create the helical detailed edges of a")}
                            {this.Block2Card("Welding",weld,"Welding is a fabrication process whereby two or more parts are fused together by means of heat, pressure or")}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {

        return (
            <div className='Service'>
                {this.Block1()}
                {this.Block2()}
            </div>
        );
    }
}